<template>
  <v-container>
    <h1><span class="text-light"></span>关于我们</h1>
    <v-row>
      <v-col>
        <div class="item-body" style="padding-top: 30px;">
          <p>
            沛熙管理咨询有限公司是一家专业的财务管理咨询公司，旗下设有顺大会计事务所有限公司、香港沛熙顾问有限公司，我们秉承“专业、诚信、创新、共赢”的服务理念，致力于为客户提供定制化的财务管理解决方案。团队汇聚资深财务管理专家、注册会计师和财务分析师，精准把握市场动态和客户需求，量身定制最适合客户的财务管理策略。
          </p>
          <p>
            我们服务范围广泛，涵盖财务规划、预算管理、成本控制、税务筹划、内部审计、风险管理等领域。同时，我们具备将财务管理与IT信息化技术相结合的优势，引入先进的财务管理软件和工具，如ERP系统、大数据分析工具等，助力企业实现数字化转型和可持续发展。
          </p>
          <p>
            我们注重与客户的长期合作和共同发展，通过定期跟踪服务、专业培训和财务健康检查等方式，确保客户财务管理水平持续提升。未来，我们将继续秉承专业精神，不断创新服务模式，以更加优质、高效的服务，助力客户实现财务目标，共创辉煌未来。
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="item-body" style="padding-left: 60px; padding-top: 0;">
          <ul class="list-marked text-gray-800">
            <li>
              <h2>专业</h2>我们坚持专业精神，不断提升团队的专业能力和服务质量，确保为客户提供精准、高效的解决方案。
            </li>
          </ul>
          <ul class="list-marked text-gray-800">
            <li>
              <h2>诚信</h2>诚信是我们的立身之本，我们承诺对客户诚实守信，维护良好的商业信誉和客户关系。
            </li>
          </ul>
          <ul class="list-marked text-gray-800">
            <li>
              <h2>创新</h2>我们鼓励创新思维，勇于探索未知领域，不断推出新颖的服务模式和产品，以满足市场的不断变化。
            </li>
          </ul>
          <ul class="list-marked text-gray-800">
            <li>
              <h2>共赢</h2>我们追求与客户、员工、合作伙伴和社会的共赢发展，通过携手合作，共同实现长远目标和价值创造。
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
    <div style="height: 100px;"></div>
  </v-container>
</template>

<script setup>

</script>

<style scoped>
.text-light {
  font-weight: 300;
}


.item-body {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
}

.item-body>p {
  text-indent: 2rem;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 16px;
}


.list-marked {
  text-align: left;
  font-weight: 300;
  font-size: 16px;
  margin-top: 16px;
  padding-left: 16px;
}

.list-marked>li {
  position: relative;
  padding-left: 10px;
  margin-top: 3px;
}


.text-gray-800 {
  color: #333;
}

.text-body-color {
  color: gray;
}
</style>